// //*for live api use uncomment============>>>>/*
export const environment = {
  production: false,
  apiUrl:'https://partnerapi.fareboutique.com/v1/',
  url:'https://partnerapi.fareboutique.com/',
  imageurl:'https://api.fareboutique.com/uploads/airlines/',
  XAPI_KEY:'1IHUKI1660135850425'
};


//*for Dev api use uncomment============>>>>*/
// export const environment = {
//   production: false,
//   apiUrl:'https://devpatnerapi.fareboutique.com/v1/',
//   url:'https://devpatnerapi.fareboutique.com/',
//   imageurl:'https://api.fareboutique.com/uploads/airlines/',
//  XAPI_KEY:'1FMQKB1639407126571'
// };